export default "__VITE_ASSET__hiY98CAk__"